import "./LessonsAudios.css";
import "react-h5-audio-player/lib/styles.css";

import { AudioData, getAudios } from "./Lessons.service";
import { useAppDispatch, useAppSelector } from "../../../store";

import H5AudioPlayer from "react-h5-audio-player";
import React from "react";
import { klassi } from "../../../utils/utils";
import { updateAudioProgressThunk } from "../../../store/slices/userThunks";

interface Props {
  slug: string;
}

export default function LessonsAudios(props: Props) {
  const { slug } = props;
  const audioRef = React.useRef<HTMLAudioElement>(null);
  const lesson = useAppSelector((state) => state.user?.user?.courses?.[slug]);
  const [selectedAudio, setSelectedAudio] = React.useState<AudioData>();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (audioRef.current && selectedAudio) {
      audioRef.current.load(); // Tell browser "Reload the <source> data"
      audioRef.current.play().catch((err) => {
        console.warn("Autoplay was prevented:", err);
      });
    }
  }, [selectedAudio]);

  const completedAudios = Object.keys(lesson?.completedAudios || {}).map(
    (a) => a + ".mp3"
  );
  const audios = getAudios(slug) || [];

  const play = (audio: AudioData) => {
    setSelectedAudio(audio);
    dispatch(updateAudioProgressThunk({ audio }));
  };

  const onAudioClick = (audio: AudioData) => {
    play(audio);
  };

  const onNext = () => {
    let i = (selectedAudio?.index || 0) + 1;
    if (i > audios.length - 1) i = audios.length - 1;
    play(audios[i]);
  };

  const onPrevious = () => {
    let i = (selectedAudio?.index || 0) - 1;
    if (i < 0) i = 0;
    play(audios[i]);
  };

  console.log("LessonsAudios", { selectedAudio, audios, completedAudios });

  return (
    <div className="audios support-column">
      <h4 className="support-title">
        Hljóðskrár
        <span className="support-subtitle">Audio</span>
      </h4>
      <div className="audio-player">
        <H5AudioPlayer
          autoPlay={true}
          src={selectedAudio?.src}
          showJumpControls={false}
          showSkipControls={true}
          onClickNext={onNext}
          onClickPrevious={onPrevious}
        />
        <div className="audio-title">{selectedAudio?.name}</div>
      </div>
      <div className="audio-list">
        {audios.map((audio) => {
          const klass = klassi(
            {
              selected: selectedAudio?.src === audio.src,
              completed: completedAudios.includes(audio.name),
            },
            "audio"
          );
          return (
            <div
              key={audio.src}
              className={klass}
              onClick={() => onAudioClick(audio)}
            >
              {audio.name}
            </div>
          );
        })}
      </div>
    </div>
  );
}
